import React, { useState } from 'react';
import Tabs from '@jwp/ott-ui-react/src/components/Tabs/Tabs';
import Tab from '@jwp/ott-ui-react/src/components/Tab/Tab';
import Fade from '@jwp/ott-ui-react/src/components/Animation/Fade/Fade';

import styles from './MediaTabs.module.scss';

const MediaTabs = ({ titles, children, isLoading }: { titles: string[]; children: React.ReactNode[]; isLoading?: boolean }) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const tabs = titles.map((title, index) => ({ title, content: children[index] })).filter(({ title }) => !!title);

  return (
    <Fade open={!isLoading} duration={500} className={styles.tabsContainer}>
      <Tabs onTabSelect={setSelectedTab} selectedTab={selectedTab}>
        {tabs.map(({ title, content }) => (
          <Tab key={title} title={title}>
            {content}
          </Tab>
        ))}
      </Tabs>
    </Fade>
  );
};

export default MediaTabs;
